export default {"src":"/_next/static/media/select-down.5284cb71.svg","height":16,"width":16};